<template>
  <article :class="rootClass">
    <header :class="`${rootClass}__header`">
      <h1 :class="`${rootClass}__title`">{{ model }}</h1>
      <div :class="`${rootClass}__price`">
        {{ price }}<span :class="`${rootClass}__unit`">/{{ unit }}</span>
      </div>
    </header>
    <div :class="`${rootClass}__body`">
      <img :class="`${rootClass}__image`" :src="image" :alt="model" />
      <VehicleCardSpecsList v-if="specs.length" :class="`${rootClass}__specs`">
        <VehicleCardSpecsListItem
          v-for="({ name, value }, index) in specs"
          :key="`vehicle-card-specs-list-item-${index}`"
          :name="name"
          :value="value"
        />
      </VehicleCardSpecsList>
    </div>
    <slot name="footer">
      <footer :class="`${rootClass}__footer`">
        <button
          type="button"
          :class="[`${rootClass}__action`, 'btn btn-dark btn-lg']">
          Reserva ahora
        </button>
      </footer>
    </slot>
  </article>
</template>

<script>
import VehicleCardSpecsList from './VehicleCardSpecsList.vue'
import VehicleCardSpecsListItem from './VehicleCardSpecsListItem.vue'

export default {
  components: {
    VehicleCardSpecsList,
    VehicleCardSpecsListItem
  },
  props: {
    model: {
      type: String,
      default: ''
    },
    price: {
      type: String,
      default: ''
    },
    image: {
      type: String,
      default: ''
    },
    unit: {
      type: String,
      default: 'día'
    },
    specs: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      rootClass: 'vehicle-card'
    }
  }
}
</script>
